import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie';
import './styles.scss';

const About = () => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    fetch("/2025/lottie/snowflakes.json")
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((error) => console.error("Error loading animation:", error));
  }, []);

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="about-section">
      {/* Blue gradient background */}
      <div className="about-background">
        <img
          src="/2025/about/background.svg"
          alt=""
          className="bg-wave"
        />
      </div>

      {/* Snowflakes - single centered */}
      {animationData && (
        <div className="snowflakes-container">
          <Lottie options={lottieOptions} />
        </div>
      )}

      {/* Centered text content */}
      <div className="about-content">
        <h2 className="about-title">Благодарим ви за доверието!</h2>
        <p className="about-subtitle">Нека през 2026-та година да вървим напред и нагоре 🚀</p>
      </div>
    </section>
  );
};

export default About;
